import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
  },
  title: {
    fontSize: '0.95rem',
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
  },
  copyButton: {
    textTransform: 'none',
    fontWeight: 600,
  },
  mitigationChip: {
    fontSize: '0.7rem',
    height: 22,
    fontWeight: 600,
    backgroundColor: theme.palette.statusLabel.warning.secondary,
    color: theme.palette.statusLabel.warning.primary,
    '& .MuiChip-icon': { color: theme.palette.statusLabel.warning.primary },
  },
  coverageSummary: {
    fontSize: '0.82rem',
    color: theme.palette.text.primary,
    lineHeight: 1.55,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  table: {
    '& th, & td': {
      verticalAlign: 'top',
      borderColor: theme.palette.divider,
    },
  },
  headCell: {
    fontSize: '0.7rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: theme.palette.text.secondary,
    fontWeight: 700,
  },
  bodyCell: {
    fontSize: '0.82rem',
    color: theme.palette.text.primary,
  },
  requirementText: {
    fontSize: '0.82rem',
    color: theme.palette.text.primary,
    lineHeight: 1.45,
  },
  statusChip: {
    fontSize: '0.7rem',
    height: 22,
    fontWeight: 600,
  },
  statusAttended: {
    backgroundColor: theme.palette.statusLabel.success.secondary,
    color: theme.palette.statusLabel.success.primary,
  },
  statusPartial: {
    backgroundColor: theme.palette.statusLabel.warning.secondary,
    color: theme.palette.statusLabel.warning.primary,
  },
  evidenceList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  evidenceReference: {
    fontSize: '0.78rem',
    color: theme.palette.text.link,
    fontWeight: 600,
  },
  howSatisfied: {
    fontSize: '0.8rem',
    color: theme.palette.text.primary,
    lineHeight: 1.45,
  },
  emptyText: {
    fontSize: '0.8rem',
    color: theme.palette.text.secondary,
  },
}))

export default useStyles
